import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useCompany() {
  const [company, setCompany] = useState({
    whatsapp: "",
    email: "",
    address: "",
    phone: "",
  });

  useEffect(() => {
    api
      .get("/company")
      .then((res) => setCompany(res.data))
      .catch(() => {});
  }, []);

  return company;
}

export function buildWhatsAppUrl(number, message) {
  const cleaned = (number || "").replace(/\D/g, "");
  const text = encodeURIComponent(
    message ||
      "Hola Vigopal, me gustaría cotizar pallets para mi empresa."
  );
  return `https://wa.me/${cleaned}?text=${text}`;
}
